var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        "d-flex justify-content-start w-100" +
        (_vm.time !== null ? " border-bottom" : ""),
    },
    [
      _c("div", { staticClass: "p-05" }, [
        _vm.supplier_data != null &&
        _vm.supplier_data.pivot.post_as === "supplier"
          ? _c("div", [
              _c("img", {
                staticClass: "round",
                attrs: {
                  src:
                    _vm.supplier_data.supplier_avatar !== null
                      ? _vm.supplier_data.supplier_avatar.url
                      : "/images/avatar.png",
                  alt: "avatar",
                  height: "40",
                  width: "40",
                },
              }),
            ])
          : _c("div", [
              _c("img", {
                staticClass: "round",
                attrs: {
                  src:
                    _vm.user_data !== null
                      ? _vm.user_data.avatar.url
                      : "/images/avatar.png",
                  alt: "avatar",
                  height: "40",
                  width: "40",
                },
              }),
            ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "p-0 pt-05 justify-content-start" }, [
        _c("div", { staticClass: "user-name text-bold-600 text-dark" }, [
          _vm.supplier_data != null &&
          _vm.supplier_data.pivot.post_as === "supplier"
            ? _c("div", { staticClass: "dropdown dropdown-user nav-item" }, [
                _c("a", {
                  staticClass: "text-dark",
                  attrs: { href: _vm.postOwnerLink },
                  domProps: { textContent: _vm._s(_vm.postOwnerName) },
                }),
              ])
            : _c("div", { staticClass: "nav-item" }, [
                _c("div", { staticClass: "nav-item" }, [
                  _c("span", {
                    domProps: { textContent: _vm._s(_vm.postOwnerName) },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    [
                      _vm.user_data.roles[0].title === "Admin"
                        ? _c("img", {
                            staticStyle: {
                              "margin-top": "-3px",
                              height: "15px",
                            },
                            attrs: {
                              src: "/images/badges/admin.png",
                              "data-toggle": "tooltip",
                              "data-placement": "bottom",
                              title: "Administrator",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.user_data.badges, function (badge) {
                        return _c("img", {
                          staticStyle: { "margin-top": "-3px", height: "15px" },
                          attrs: {
                            src: badge.image,
                            "data-toggle": "tooltip",
                            "data-placement": "bottom",
                            title: badge.name,
                          },
                        })
                      }),
                      _vm._v(" "),
                      _vm.user_data.user_badge_id !== null &&
                      _vm.user_data.user_badge_image != null
                        ? _c("img", {
                            staticStyle: {
                              "margin-top": "-3px",
                              height: "15px",
                            },
                            attrs: {
                              src: _vm.user_data.user_badge_image.url,
                              "data-toggle": "tooltip",
                              "data-placement": "bottom",
                              title: _vm.user_data.user_badge_name,
                            },
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.shared === true
                    ? _c("span", { staticClass: "text-bold-400" }, [
                        _vm._v(
                          _vm._s(_vm.__("globals.shared")) +
                            " a " +
                            _vm._s(_vm.type)
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
        ]),
        _vm._v(" "),
        _vm.supplier_data != null &&
        _vm.supplier_data.pivot.post_as === "supplier"
          ? _c("div", { staticStyle: { "margin-top": "-5px" } }, [
              _c("span", {
                staticClass: "font-small-2 text-primary",
                domProps: { textContent: _vm._s("@" + _vm.supplier_data.slug) },
              }),
            ])
          : _c(
              "div",
              {
                staticClass: "mr-2",
                staticStyle: { "margin-top": "3px", "line-height": "1" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "user-name text-bold-600",
                    staticStyle: { "margin-top": "-5px" },
                  },
                  [
                    _c("span", {
                      staticClass: "font-small-2 text-muted",
                      domProps: { textContent: _vm._s(_vm.user_data.position) },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-small-2 text-muted" }, [
                      _vm._v(" |"),
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "font-small-2 text-muted",
                      domProps: {
                        textContent: _vm._s(_vm.user_data.organisation),
                      },
                    }),
                  ]
                ),
              ]
            ),
      ]),
      _vm._v(" "),
      _vm.time !== null
        ? _c(
            "div",
            {
              staticClass: "btn-group mt-05",
              staticStyle: { right: "0.5rem", position: "absolute" },
            },
            [
              _c("span", {
                staticClass: "font-small-1 text-light",
                staticStyle: { "margin-top": "4px" },
                domProps: { textContent: _vm._s(_vm.ago) },
              }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }